var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctorate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.558716,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 21.0587C9.5 20.2303 10.1716 19.5587 11 19.5587C11.8284 19.5587 12.5 20.2303 12.5 21.0587V28.0587C12.5 28.8871 11.8284 29.5587 11 29.5587C10.1716 29.5587 9.5 28.8871 9.5 28.0587V21.0587Z",
    fill: "#00AAEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.0587C14 18.2303 14.6716 17.5587 15.5 17.5587C16.3284 17.5587 17 18.2303 17 19.0587V28.0587C17 28.8871 16.3284 29.5587 15.5 29.5587C14.6716 29.5587 14 28.8871 14 28.0587V19.0587Z",
    fill: "#00AAEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 17.0587C18.5 16.2303 19.1716 15.5587 20 15.5587C20.8284 15.5587 21.5 16.2303 21.5 17.0587V28.0587C21.5 28.8871 20.8284 29.5587 20 29.5587C19.1716 29.5587 18.5 28.8871 18.5 28.0587V17.0587Z",
    fill: "#00AAEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15.0587C23 14.2303 23.6716 13.5587 24.5 13.5587C25.3284 13.5587 26 14.2303 26 15.0587V28.0587C26 28.8871 25.3284 29.5587 24.5 29.5587C23.6716 29.5587 23 28.8871 23 28.0587V15.0587Z",
    fill: "#00AAEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 13.0587C27.5 12.2303 28.1716 11.5587 29 11.5587C29.8284 11.5587 30.5 12.2303 30.5 13.0587V28.0587C30.5 28.8871 29.8284 29.5587 29 29.5587C28.1716 29.5587 27.5 28.8871 27.5 28.0587V13.0587Z",
    fill: "#00AAEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorate);
export default __webpack_public_path__ + "static/media/doctorate.a7ac761687a64a61795a31b3a6443197.svg";
export { ForwardRef as ReactComponent };